(function () {
  const CAN_SIZE_G = 225;

  // Empfehlungen bevorzugen die größere Variante + das längste der vier
  // vordefinierten Lieferintervalle (30/45/60/90 Tage), sofern die Deckung
  // dabei im sicheren Bereich (0,85–1,6) bleibt.
  const WEIGHT_TABLE = [
    { max: 4.9, label: 'bis 4,9 kg', dailyDoseG: 2.5, recCanCount: 1, recIntervalDays: 90 },
    { max: 7.9, label: '5–7,9 kg', dailyDoseG: 5, recCanCount: 3, recIntervalDays: 90 },
    { max: 27.9, label: '8–27,9 kg', dailyDoseG: 7, recCanCount: 3, recIntervalDays: 90 },
    { max: 44.9, label: '28–44,9 kg', dailyDoseG: 10.5, recCanCount: 6, recIntervalDays: 90 },
    { max: 69.9, label: '45–69,9 kg', dailyDoseG: 14, recCanCount: 6, recIntervalDays: 90 },
    { max: Infinity, label: 'ab 70 kg', dailyDoseG: 17.5, recCanCount: 6, recIntervalDays: 60 },
  ];

  function getBracket(weightKg) {
    return WEIGHT_TABLE.find((b) => weightKg <= b.max) || WEIGHT_TABLE[WEIGHT_TABLE.length - 1];
  }

  function getCoverage(dailyDoseG, canCount, intervalDays) {
    return (canCount * CAN_SIZE_G) / (dailyDoseG * intervalDays);
  }

  // Wechselt die Variante über den echten Theme-Variantenpicker (<variant-selects>).
  // Loops eigenes Widget (Kaufoptionen, Preise, Selling-Plan-Buttons) bleibt
  // unangetastet und reagiert selbst auf den Variantenwechsel.
  function selectRealVariant(title) {
    return new Promise((resolve) => {
      const picker = document.querySelector('variant-selects');
      const input = title && picker
        ? Array.from(picker.querySelectorAll('input[type="radio"]')).find((el) => el.value === title)
        : null;

      if (!input) {
        console.warn('[Dog-Calc] Variantenpicker-Input nicht gefunden für:', title);
        resolve();
        return;
      }
      if (input.checked) {
        resolve();
        return;
      }

      const onChanged = () => {
        document.removeEventListener('variant:changed', onChanged);
        clearTimeout(fallback);
        resolve();
      };
      const fallback = setTimeout(() => {
        document.removeEventListener('variant:changed', onChanged);
        resolve();
      }, 2000);

      document.addEventListener('variant:changed', onChanged);
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Klickt den Lieferintervall-Button im echten Loop-Widget, dessen sichtbarer
  // Text zum gewählten Intervall passt — per Text statt per Selling-Plan-ID,
  // damit es unabhängig davon funktioniert, welche ID Loop gerade für die
  // aktuelle Variante anzeigt. Sicher, weil der Rechner ohnehin erst sichtbar
  // ist, nachdem "Abonnieren und sparen" bereits gewählt wurde.
  function selectRealInterval(days) {
    const buttons = document.querySelectorAll('.loop-widget-sp-button');
    const target = Array.from(buttons).find(
      (btn) => btn.textContent.replace(/\s+/g, ' ').trim() === `Lieferung alle ${days} Tage`
    );
    if (target && target.getAttribute('aria-checked') !== 'true') {
      target.click();
    }
  }

  // Zeigt den Rechner nur, solange im echten Loop-Widget "Abonnieren und
  // sparen" ausgewählt ist. Beobachtet den stabilen Widget-Container statt
  // eines einzelnen Kindknotens und fragt dessen aktuellen Zustand bei jeder
  // Änderung frisch ab — falls Loop beim Klick den Knoten ersetzt statt nur
  // ein Attribut zu ändern, bleibt die Beobachtung trotzdem gültig.
  function watchPurchaseOption(root) {
    const container = document.querySelector('[id^="loop-widget-container-id-"]');
    if (!container) return;

    const update = () => {
      const subscribeOption = document.querySelector(
        '[data-loop-widget-purchase-option][data-selling-plan-group-id]'
      );
      root.classList.toggle('is-visible', subscribeOption?.getAttribute('aria-checked') === 'true');
    };

    update();
    new MutationObserver(update).observe(container, {
      attributes: true,
      attributeFilter: ['aria-checked'],
      subtree: true,
      childList: true,
    });
    container.addEventListener('click', update);
  }

  function init(root) {
    watchPurchaseOption(root);

    const weightInput = root.querySelector('.dog-calc__weight-input');
    const weightSlider = root.querySelector('.dog-calc__weight-slider');
    const chipRow = root.querySelector('.dog-calc__chip-row');
    const dailyDoseText = root.querySelector('.dog-calc__daily-dose');
    const canDurationText = root.querySelector('.dog-calc__can-duration');
    const intervalSelect = root.querySelector('.dog-calc__interval-select');
    const variantRow = root.querySelector('.dog-calc__variant-row');
    const coverageLow = root.querySelector('.dog-calc__coverage-note.low');
    const coverageLowText = coverageLow.querySelector('.dog-calc__coverage-text');
    const coverageHigh = root.querySelector('.dog-calc__coverage-note.high');
    const coverageHighText = coverageHigh.querySelector('.dog-calc__coverage-text');

    const initialActiveBtn = variantRow.querySelector('.is-active');
    let selectedCanCount = initialActiveBtn
      ? Number(initialActiveBtn.dataset.canCount)
      : WEIGHT_TABLE[0].recCanCount;
    let canCountTouched = false;
    let intervalTouched = false;
    let hasInteracted = false;
    let applyTimer = null;

    function currentInterval() {
      return Number(intervalSelect?.value) || null;
    }

    WEIGHT_TABLE.forEach((bracket, i) => {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'dog-calc__chip';
      chip.textContent = bracket.label;
      chip.addEventListener('click', () => {
        let midpoint;
        if (bracket.max === Infinity) {
          // Offene letzte Klasse hat keine Obergrenze — repräsentativen Wert
          // oberhalb der vorherigen Grenze nehmen statt mit Infinity zu rechnen.
          midpoint = WEIGHT_TABLE[i - 1].max + 10;
        } else if (i === 0) {
          midpoint = bracket.max / 2;
        } else {
          midpoint = (WEIGHT_TABLE[i - 1].max + bracket.max) / 2;
        }
        setWeight(Math.round(midpoint * 2) / 2);
      });
      chipRow.appendChild(chip);
    });

    Array.from(variantRow.children).forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        selectedCanCount = Number(btn.dataset.canCount);
        canCountTouched = true;
        hasInteracted = true;
        render();
        scheduleApply();
      });
    });

    function setWeight(kg) {
      weightInput.value = kg;
      weightSlider.value = kg;
      canCountTouched = false;
      intervalTouched = false;
      hasInteracted = true;
      render();
      scheduleApply();
    }

    function render() {
      const weightKg = Number(weightInput.value) || 0;
      const bracket = getBracket(weightKg);

      Array.from(chipRow.children).forEach((chip, i) => {
        chip.classList.toggle('is-active', WEIGHT_TABLE[i] === bracket);
      });

      dailyDoseText.textContent = bracket.dailyDoseG.toString().replace('.', ',') + ' g / Tag';
      const daysPerCan = Math.round(CAN_SIZE_G / bracket.dailyDoseG);
      canDurationText.textContent = daysPerCan + ' Tage';

      if (!canCountTouched) selectedCanCount = bracket.recCanCount;

      Array.from(variantRow.children).forEach((btn) => {
        btn.classList.toggle('is-active', Number(btn.dataset.canCount) === selectedCanCount);
      });

      if (intervalSelect && !intervalTouched) {
        intervalSelect.value = String(bracket.recIntervalDays);
      }

      updateCoverageNote(bracket);
      return bracket;
    }

    function updateCoverageNote(bracket) {
      coverageLow.classList.remove('is-visible');
      coverageHigh.classList.remove('is-visible');

      const intervalDays = currentInterval() || bracket.recIntervalDays;
      const coverage = getCoverage(bracket.dailyDoseG, selectedCanCount, intervalDays);
      const reachDays = Math.round((selectedCanCount * CAN_SIZE_G) / bracket.dailyDoseG);

      if (coverage < 0.85) {
        coverageLowText.textContent =
          `Bei diesem Gewicht reicht ${selectedCanCount === 1 ? '1 Dose' : selectedCanCount + ' Dosen'} ca. ${reachDays} Tage. ` +
          `Für eine durchgehende Versorgung empfehlen wir mindestens ${bracket.recCanCount} Dose${bracket.recCanCount > 1 ? 'n' : ''} ` +
          `alle ${bracket.recIntervalDays} Tage.`;
        coverageLow.classList.add('is-visible');
      } else if (coverage > 1.6) {
        coverageHighText.textContent =
          `Bei diesem Gewicht reicht diese Menge ca. ${reachDays} Tage. ` +
          `Möchten Sie stattdessen ein selteneres Lieferintervall wählen?`;
        coverageHigh.classList.add('is-visible');
      }
    }

    // Nur nach einer aktiven Kundeninteraktion an den echten Variantenpicker
    // und die Loop-Intervall-Buttons weitergeben — beim ersten Rendern mit
    // dem Standardgewicht soll noch nichts automatisch ausgelöst werden.
    function scheduleApply() {
      if (!hasInteracted) return;
      clearTimeout(applyTimer);
      applyTimer = setTimeout(applyRealSelection, 450);
    }

    async function applyRealSelection() {
      const btn = variantRow.querySelector(`[data-can-count="${selectedCanCount}"]`);
      if (btn) {
        await selectRealVariant(btn.textContent.trim());
      }
      const intervalDays = currentInterval();
      if (intervalDays) {
        selectRealInterval(intervalDays);
      }
    }

    weightInput.addEventListener('input', () => {
      weightSlider.value = weightInput.value;
      canCountTouched = false;
      intervalTouched = false;
      hasInteracted = true;
      render();
      scheduleApply();
    });
    weightSlider.addEventListener('input', () => {
      weightInput.value = weightSlider.value;
      canCountTouched = false;
      intervalTouched = false;
      hasInteracted = true;
      render();
      scheduleApply();
    });

    intervalSelect?.addEventListener('change', () => {
      intervalTouched = true;
      hasInteracted = true;
      updateCoverageNote(getBracket(Number(weightInput.value) || 0));
      scheduleApply();
    });

    // Menge wird über den echten (sichtbaren) Variantenpicker gewählt, nicht
    // über die hier versteckten Buttons — ohne das hier würde eine manuelle
    // Auswahl dort nie im Rechner ankommen und die Deckungswarnung würde
    // weiterhin von der letzten Empfehlung statt der tatsächlichen Menge
    // ausgehen.
    document.addEventListener('variant:changed', (event) => {
      const title = event.detail?.variant?.title;
      const btn = title
        ? Array.from(variantRow.children).find((b) => b.textContent.trim() === title)
        : null;
      if (!btn) return;
      const newCanCount = Number(btn.dataset.canCount);
      if (newCanCount === selectedCanCount) return;
      selectedCanCount = newCanCount;
      canCountTouched = true;
      render();
    });

    render();
  }

  document.querySelectorAll('.dog-calc').forEach(init);
})();
